"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SkipNavigation;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("@ux/button"));
const _excluded = ["skipToId", "text"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function SkipNavigation(_ref) {
  let {
      skipToId,
      text
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const [skipTarget, setSkipTarget] = (0, _react.useState)('#main-content');
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined') {
      const focusOn = [`#${skipToId}`, '#main', '#root'].find(sel => document.querySelector(sel));
      if (focusOn) {
        setSkipTarget(focusOn);
      }
    }
  }, [skipToId]);
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    className: "skip-navigation",
    text: text,
    href: skipTarget,
    design: "secondary",
    "data-cy": "skip-navigation"
  }, rest));
}
SkipNavigation.propTypes = {
  skipToId: _propTypes.default.string,
  text: _propTypes.default.string
};
SkipNavigation.defaultProps = {
  skipToId: 'main-content'
};